import { useState } from "react";
import { FiGlobe, FiChevronDown } from "react-icons/fi";
import { useLanguage } from "../contexts/LanguageContext";
import { useTranslation } from "../hooks/useTranslation";

const languages = [
    { code: "en", name: "English" },
    { code: "zh", name: "中文" },
    { code: "zh-TW", name: "繁體" },
    { code: "ko", name: "한국어" },
    { code: "vi", name: "Tiếng Việt" },
    { code: "hi", name: "हिन्दी" },
    { code: "id", name: "Bahasa Indonesia" },
    { code: "ta", name: "தமிழ்" },
    { code: "ja", name: "日本語" },
    { code: "ru", name: "Русский" },
];

export default function LanguageSwitcher() {
    const { language, changeLanguage } = useLanguage();
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const currentLanguage = languages.find((lang) => lang.code === language);

    const handleLanguageChange = (langCode) => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-2 px-3 py-2 text-[#fff] hover:text-[#fff]/80 rounded-lg transition-colors"
            >
                <FiGlobe className="size-4" />
                <span className="text-sm font-medium">
                    {currentLanguage?.name}
                </span>
                <FiChevronDown className="size-3" />
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            onClick={() => handleLanguageChange(lang.code)}
                            className={`w-full flex items-center space-x-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors ${language === lang.code
                                    ? "bg-blue-50 text-blue-600"
                                    : "text-gray-700"
                                }`}
                        >
                            <span className="font-medium">{lang.name}</span>
                            {language === lang.code && (
                                <div className="ml-auto size-2 bg-blue-500 rounded-full"></div>
                            )}
                        </button>
                    ))}
                </div>
            )}

            {/* Overlay to close dropdown when clicking outside */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-40"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
}
